import { LOGIN, RESET_PASSWORD,FORGOT_PASSWORD } from "./constant";

export function loginRequest(data){
  return {
    type:LOGIN.PENDING,
    data,
  }
}

export function loginSuccess(data){
  return {
    type:LOGIN.SUCCESS,
    data
  }
}

export function loginError(err){
  return {
    type:LOGIN.ERROR,
    err
  }
}

export function forgotPasswordRequest(data) {
  return {
    type:FORGOT_PASSWORD.PENDING,
    data
  }
}

export function forgotPasswordSuccess(data) {
  return {
    type:FORGOT_PASSWORD.SUCCESS,
    data
  }
}

export function forgotPasswordError(err) {
  return {
    type:FORGOT_PASSWORD.ERROR,
    err
  }
}

export function resetPasswordRequest(data) {
  return {
  type:RESET_PASSWORD.PENDING,
  data
  }
}

export function resetPasswordSuccess(data) {
  return {
    type:RESET_PASSWORD.SUCCESS,
    data
  }
}

export function resetPasswordError(data) {
  return {
    type:RESET_PASSWORD.ERROR,
    data
  }
}
